import { ReactNode } from 'react';
import { ByoAnalyticType, ByoWord } from "@pages/Byo/ByoContext";
import { SlicesEnum } from "@models/ByoTableData";

export type ColumnOption = { id: string; title: ReactNode; isActive: boolean };
export type OptionsType = ColumnOption[];

export interface ByoChartDataItem {
    id: number;
    name: string;
    value: string;
    valueNumeric: number;
    baseSize: string;
}

export interface ByoTableChartData {
    actualData: ByoChartDataItem[];
    predictedData: ByoChartDataItem[];
    actualDataQuarters: ByoChartDataItem[];
    predictedDataQuarters: ByoChartDataItem[];
}

export type ByoTableRow = ByoWord['keyword'] & {
    color: string;
    isLoading?: boolean;
    columnsValues: ReactNode[];
    chartData: ByoChartDataItem[];
}

export type ByoTableItem = ByoWord & {
    columnsValues: string[];
    chartData: ByoTableChartData;
}

export interface ByoTableColumn {
    id: number;
    sliceId: SlicesEnum;
    key: string;
    name: ReactNode;
    sortKey: string;
    isClickable?: boolean;
    isDark?: boolean;
    isMedium?: boolean;
    tooltipTitle?: string;
    tooltipDescription?: string;
    tooltipImageUrl?: string;
    footerContent: string;
}

export const baseSizeTitleMap: Record<ByoAnalyticType, string> = {
    [ByoAnalyticType.Penetration]: 'Number of restaurants',
    [ByoAnalyticType.Incidence]: 'Number of items',
    [ByoAnalyticType.Price]: 'Median price',
};
